'use client';

import { useEffect } from 'react';
import LogRocket from 'logrocket';

export function LogRocketProvider() {
  useEffect(() => {
        LogRocket.init('g8fxnc/ninjaz');
  }, []);

  return null; // nothing to render
}
